<div *ngIf="testActionsPresent === false" class="Flexbox">
    <button (click)="toggleNotes();collapseAttachments();"
            [disabled]="!revisionId"
            class="img-btn notes-btn top-template-header-content-item fs5 scale"
            genTooltip tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="Notes">
        <i class="icon__notifications" style="font-size: 1.57rem;">
            <span *ngIf="newNotes > 0" class="new-notes-notification">{{newNotes}}</span>
        </i>
    </button>
    <button (click)="toggleAttachments();collapseNotes();"
            [disabled]="!revisionId"
            class="img-btn notes-btn top-template-header-content-item fs5 scale"
            genTooltip tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="REPORTS_AND_DOCUMENTS">
        <i class="icon__attachment" style="font-size: 1.57rem;">
        </i>
    </button>
    <gen-revise
            (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
            *ngIf="isPerformer"
            [revisionId]="revisionId"
            [templatesConfiguration]="reviseTemplates"
            [testType]="id"
            [tooltipHtml]="'Advance/Revise item'"
            [tooltipPosition]="toolTipPositions.BOTTOM"
            [workflow]="currentWorkflow"
            class="img-btn notes-btn fs6 scale"
    ></gen-revise>
    <gen-back
            (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
            *ngIf="testInDraftMode && isPerformer && !hideBackActionButton"
            [disabled]="!testIsCompleted"
            [revisionId]="revisionId"
            [templatesConfiguration]="reviseTemplates"
            [testType]="id"
            [tooltipHtml]="'Back'"
            [tooltipPosition]="toolTipPositions.BOTTOM"
            [workflow]="currentWorkflow"
            class="img-btn btn-back fs6 scale"
    ></gen-back>
    <button (click)="removeFromWorklist()"
            *ngIf="editModeIsSupported() && latestRevisionId === currentRevision?.id && testInWorklist && !hideRemoveFromWorklist()"
            [permissionSchemaKey]="'workflowAnalysisRemove'"
            class="img-btn notes-btn top-template-header-content-item fs5 scale"
            genPermissionSchemaRestrict
            genTooltip tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="Remove from worklist">
            <span class="icon__cross" style="font-size:1.5rem;">
            </span>
    </button>
    <button (click)="reassign()"
            *ngIf="reassignIsEnabled()"
            [tooltipPosition]="'BOTTOM'"
            [tooltipText]="'Reassign Item'"
            class="img-btn notes-btn top-template-header-content-item fs5 scale" genTooltip tooltipShow="true" type="button">
        <span class="icon__reassign" style="font-size:1.5rem;"></span>
    </button>
    <gen-stop-workflow
            *ngIf="stopActionItem.enable"
            [activeJobItem]="getActiveJobItem()"
            [cssClass]="'img-btn notes-btn fs5 scale'"
            [currentWorkflow]="currentWorkflow"
            [stopAction]="stopActionItem"
            [styleItem]="{'font-size': '1.5rem'}"
            [tooltipPosition]="'BOTTOM'"
            [tooltipText]="stopActionItem.label"
    ></gen-stop-workflow>
</div>

<span *ngFor="let testAction of testActions" [ngSwitch]="testAction.action" class="Flexbox"
      style="padding-left:0.1rem;">
          <span *ngIf="testAction.labelAvailable === false">
             <button (click)="toggleNotes();collapseAttachments();" *ngSwitchCase="'notes'"
                     [disabled]="!revisionId || !testAction.enable"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip
                     style="color:white" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="Notes">
              <i *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size: 1.57rem;">
                <span *ngIf="newNotes > 0" class="new-notes-notification">{{newNotes}}</span>
              </i>
              <i *ngIf="testAction.actionIconAvailable === false" class="icon__notifications"
                 style="font-size: 1.57rem;">
                <span *ngIf="newNotes > 0" class="new-notes-notification">{{newNotes}}</span>
              </i>
            </button>

          </span>

          <span *ngIf="testAction.labelAvailable">
             <button (click)="toggleNotes();collapseAttachments();" *ngSwitchCase="'notes'"
                     [disabled]="!revisionId || !testAction.enable"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip
                     style="color:white" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="{{testAction.label}}">
              <i *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size: 1.57rem;">
                <span *ngIf="newNotes > 0" class="new-notes-notification">{{newNotes}}</span>
              </i>
              <i *ngIf="testAction.actionIconAvailable === false" class="icon__notifications"
                 style="font-size: 1.57rem;">
                <span *ngIf="newNotes > 0" class="new-notes-notification">{{newNotes}}</span>
              </i>
            </button>

          </span>


          <span *ngIf="testAction.labelAvailable">
             <button (click)="toggleAttachments();collapseNotes();" *ngSwitchCase="'attachments'"
                     [disabled]="!revisionId || !testAction.enable"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip
                     style="color:white" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="{{testAction.label}}">
                        <i *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}"
                           style="font-size: 1.57rem;">
                        </i>
                        <i *ngIf="testAction.actionIconAvailable === false" class="icon__attachment"
                           style="font-size: 1.57rem;">
                      </i>
                    </button>

          </span>

          <span *ngIf="testAction.labelAvailable === false">
             <button (click)="toggleAttachments();collapseNotes();" *ngSwitchCase="'attachments'"
                     [disabled]="!revisionId || !testAction.enable"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip
                     style="color:white" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="Reports & documents">
                        <i *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}"
                           style="font-size: 1.57rem;">
                        </i>
                        <i *ngIf="testAction.actionIconAvailable === false" class="icon__attachment"
                           style="font-size: 1.57rem;">
                      </i>
                    </button>

          </span>

          <span *ngIf="testAction.labelAvailable && testAction.enable">

             <div *ngSwitchCase="'revise'">
              <gen-revise
                      (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
                      *ngIf="isPerformer"
                      [revisionId]="revisionId"
                      [templatesConfiguration]="reviseTemplates"
                      [testType]="id"
                      [tooltipHtml]="testAction.label"
                      [tooltipPosition]="toolTipPositions.BOTTOM"
                      [workflow]="currentTest.workflowRequest"
                      class="img-btn notes-btn fs6 scale"
              ></gen-revise>
          </div>

          </span>

          <span *ngIf="testAction.labelAvailable === false && testAction.enable">

             <div *ngSwitchCase="'revise'">
              <gen-revise
                      (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
                      *ngIf="isPerformer"
                      [revisionId]="revisionId"
                      [templatesConfiguration]="reviseTemplates"
                      [testType]="id"
                      [tooltipHtml]="'Advance/Revise item'"
                      [tooltipPosition]="toolTipPositions.BOTTOM"
                      [workflow]="currentTest.workflowRequest"
                      class="img-btn notes-btn fs6 scale"
              ></gen-revise>
          </div>

          </span>

          <div *ngSwitchCase="'removeFromWorkList'">
            <span *ngIf="testAction.labelAvailable === false">
               <button (click)="removeFromWorklist()"
                       *ngIf="editModeIsSupported() && latestRevisionId === currentRevision?.id && testInWorklist && !hideRemoveFromWorklist()"
                       [disabled]="!testAction.enable"
                       [permissionSchemaKey]="'workflowAnalysisRemove'"
                       class="img-btn notes-btn top-template-header-content-item fs5 scale"
                       genPermissionSchemaRestrict
                       genTooltip
                       style="color: white;" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="Remove from worklist">
                <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;">
                </span>
                <span *ngIf="testAction.actionIconAvailable === false" class="icon__cross" style="font-size:1.5rem;">
                </span>
              </button>
            </span>
            <span *ngIf="testAction.labelAvailable">
               <button (click)="removeFromWorklist()"
                       *ngIf="editModeIsSupported() && latestRevisionId === currentRevision?.id && testInWorklist && !hideRemoveFromWorklist()"
                       [disabled]="!testAction.enable" [permissionSchemaKey]="'workflowAnalysisRemove'"
                       class="img-btn notes-btn top-template-header-content-item fs5 scale"
                       genPermissionSchemaRestrict
                       genTooltip
                       style="color: white;" tooltipPosition="BOTTOM" tooltipShow="true" tooltipText="{{testAction.label}}">
                <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;">
                </span>
                <span *ngIf="testAction.actionIconAvailable === false" class="icon__cross" style="font-size:1.5rem;">
                </span>
              </button>
            </span>
          </div>
         <ng-container *ngIf="reassignIsEnabled()">
          <span *ngIf="testAction.labelAvailable === false">
             <button (click)="reassign()" *ngSwitchCase="'reassign'"
                     [disabled]="!testAction.enable"
                     [tooltipPosition]="'BOTTOM'"
                     [tooltipText]="'Reassign Item'"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip style="color: white;" tooltipShow="true" type="button">
            <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
            <span *ngIf="testAction.actionIconAvailable === false" class="icon__reassign"
                  style="font-size:1.5rem;"></span>
          </button>
          </span>
          <span *ngIf="testAction.labelAvailable">
             <button (click)="reassign()" *ngSwitchCase="'reassign'"
                     [disabled]="!testAction.enable"
                     [tooltipPosition]="'BOTTOM'"
                     [tooltipText]="testAction.label"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip style="color: white;" tooltipShow="true" type="button">
            <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
            <span *ngIf="testAction.actionIconAvailable === false" class="icon__reassign"
                  style="font-size:1.5rem;"></span>
          </button>
          </span>
          <span *ngIf="testAction.labelAvailable === false">
             <button (click)="patientDetails()" *ngSwitchCase="'patientDetails'"
                     [disabled]="!testAction.enable"
                     [tooltipPosition]="'BOTTOM'"
                     [tooltipText]="'Patient Details'"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     genTooltip style="color: white;" type="button">
            <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
            <span *ngIf="testAction.actionIconAvailable === false" class="icon__patient"
                  style="font-size:1.5rem;"></span>
            </button>
          </span>
          <span *ngIf="testAction.labelAvailable">
            <button (click)="patientDetails()" *ngSwitchCase="'patientDetails'"
                    [disabled]="!testAction.enable"
                    [tooltipPosition]="'BOTTOM'"
                    [tooltipText]="testAction.label"
                    class="img-btn notes-btn top-template-header-content-item fs5 scale"
                    genTooltip style="color: white;" type="button">
            <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
            <span *ngIf="testAction.actionIconAvailable === false" class="icon__patient"
                  style="font-size:1.5rem;"></span>
            </button>
          </span>

         <span *ngIf="testAction.enable">
             <div *ngSwitchCase="'stop'">
              <gen-stop-workflow
                      *ngIf="isPerformer"
                      [activeJobItem]="getActiveJobItem()"
                      [cssClass]="'img-btn notes-btn fs5 scale'"
                      [currentWorkflow]="currentWorkflow"
                      [stopAction]="stopActionItem"
                      [styleItem]="{'font-size': '1.5rem'}"
                      [tooltipPosition]="'BOTTOM'"
                      [tooltipText]="testAction.label"
              ></gen-stop-workflow>
          </div>
         </span>

          <drop-down-menu
                  [disabled]="!testAction.enable"
                  [menuClassName]="testAction.icon"
                  [menuItems]="testAction.actionList"
                  [permissionId]="testAction.permissionId"
                  [tooltipHtml]="testAction.label"
                  class="img-btn notes-btn fs6 scale"
          ></drop-down-menu>

         </ng-container>
</span>
